var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.63636 12.0908H3.81818C2.81818 12.0908 2 12.909 2 13.909V19.3635C2 20.3635 2.81818 21.1817 3.81818 21.1817H5.63636C6.63636 21.1817 7.45455 20.3635 7.45455 19.3635V13.909C7.45455 12.909 6.63636 12.0908 5.63636 12.0908Z",
    fill: "#8C56E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9093 3H11.0911C10.0911 3 9.27295 3.81818 9.27295 4.81818V19.3636C9.27295 20.3636 10.0911 21.1818 11.0911 21.1818H12.9093C13.9093 21.1818 14.7275 20.3636 14.7275 19.3636V4.81818C14.7275 3.81818 13.9093 3 12.9093 3Z",
    fill: "#8C56E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.1818 8.45459H18.3636C17.3636 8.45459 16.5454 9.27277 16.5454 10.2728V19.3637C16.5454 20.3637 17.3636 21.1819 18.3636 21.1819H20.1818C21.1818 21.1819 22 20.3637 22 19.3637V10.2728C22 9.27277 21.1818 8.45459 20.1818 8.45459Z",
    fill: "#8C56E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsColored);
export default __webpack_public_path__ + "static/media/analytics_colored.8c71b42483a277566e9afa8643161086.svg";
export { ForwardRef as ReactComponent };